import { useTheme, useWindowProperties } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ConfirmationCard } from '~/components/shared/ConfirmationCard/ConfirmationCard';
import { getHomePageByMarket } from '~/constants/markets';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { clearCardApplicationState } from '~/store/slices/cardApplication.slice';
import {
  GoldenRatioContainer,
  StandardPageContainer,
} from '~/styles/BaseStyledComponents';

export const ConfirmationPage = () => {
  const t = useTranslate();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { market, language } = useSelector((state: RootState) => state.intl);
  const userId = useSelector(
    (state: RootState) => state.cardApplication.userId
  );
  const { isMobile } = useWindowProperties();
  const theme = useTheme();

  const onClickGoToWebsite = () => {
    if (userId) {
      dispatch(clearCardApplicationState());
      history.push('/');
    } else {
      window.location.assign(getHomePageByMarket(market, language));
    }
  };

  return (
    <StandardPageContainer
      style={{
        backgroundColor: theme.fn.themeColor('Page/Option_2_(Green)'),
      }}
      data-testid="card_application_confirmation_page"
    >
      <GoldenRatioContainer $grow={isMobile}>
        <ConfirmationCard
          header={t('CardApplication.ConfirmationTitle') as string}
          text={t('CardApplication.ConfirmationDescription') as string}
          buttonText={t('Onboarding.GoToQredWebsite') as string}
          onButtonClick={onClickGoToWebsite}
        />
      </GoldenRatioContainer>
    </StandardPageContainer>
  );
};
